import { Component } from '@angular/core';
import { environment } from '../environments/environment'
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  v = environment.version
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/app.component.ts